import { useMemo } from 'react';
import MaintenanceNotice from '../shared/MaintenanceNotice';

type MarketplaceMaintenancePageProps = {
  messageMap?: Record<string, string>;
};

const MarketplaceMaintenancePage = ({ messageMap }: MarketplaceMaintenancePageProps) => {
  const messages = useMemo(() => Object.values(messageMap ?? {}), [messageMap]);

  return <MaintenanceNotice messages={messages} />;
};

export default MarketplaceMaintenancePage;
